"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DEFAULT_COUNTY_MUNI = void 0;
var ADMIN_PERMISSIONS = {
  allowAllTransformers: true
};
var BASE_PERMISSIONS = {
  allowAllTransformers: false
};
var permissions = {
  COMED_ADMIN: ADMIN_PERMISSIONS,
  ACCOUNT_MANAGER: ADMIN_PERMISSIONS,
  EXTERNAL_AFFAIRS_MANAGER: ADMIN_PERMISSIONS,
  COMED_USER: ADMIN_PERMISSIONS,
  MUNI_USER: BASE_PERMISSIONS,
  LIAISON: BASE_PERMISSIONS,
  COUNTY_USER: BASE_PERMISSIONS,
  COUNTY_LIAISON: BASE_PERMISSIONS,
  UNKNOWN: BASE_PERMISSIONS
};
var DEFAULT_COUNTY_MUNI = 'COMED';
exports.DEFAULT_COUNTY_MUNI = DEFAULT_COUNTY_MUNI;
var _default = permissions;
exports.default = _default;